import { Controller, useFormContext } from "react-hook-form";
import { ISelectableGroup } from "./FormElementTypes";
import Selectable from "./Selectable";
import { useEffect } from "react";

export default function SelectableGroup({
  answer,
  options,
  isRevealed,
  qId,
  isDisabled = false,
  type,
  ...rest
}: ISelectableGroup) {
  const { control, setValue } = useFormContext();

  useEffect(() => {
    setValue("answer", rest.defaultValue)
  }, [rest.defaultValue, setValue]);


  return (
    <fieldset
      className="gap-1.5 flex flex-col items-start relative"
      disabled={isDisabled}
    >
      {type === "MULTI" && (
        <p className="text-xs text-myGreen font-medium mb-1.5">
          Bu soruda birden fazla şık seçebilirsin.
        </p>
      )}
      <Controller
        name="answer"
        control={control}
        rules={{ required: "Göndermeden önce seçim yapmalısın" }}
        render={({ field: { value, onChange } }) => {

          return (
            <>
              {options.map((opt, i) => {
                const optionValue = String(i + 1);
                const isChecked =
                  type === "MULTI"
                    ? (value || []).includes(optionValue)
                    : value === optionValue;

                return (
                  <Selectable
                    key={`${qId}_${i}`}
                    type={type}
                    isCorrect={answer.split(",").includes(optionValue)}
                    isRevealed={isRevealed}
                    label={opt}
                    order={i}
                    isDisabled={isDisabled}
                    name={String(qId)}
                    checked={isChecked}
                    onChange={(checked) => {
                      if (type === "MULTI") {
                        if (checked) {
                          onChange([...value, optionValue]);
                        } else {
                          onChange(
                            value.filter((v: string) => v !== optionValue)
                          );
                        }
                      } else {
                        if (checked) {
                          onChange(optionValue);
                        }
                      }
                    }}
                  />
                );
              })}
            </>
          )
        }}
      />
    </fieldset>
  );
}
